import moment from 'moment';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';

const StyledTypography = styled(Typography)(({ theme }) => ({
  display: 'inline',
  color: theme.palette.text.secondary
}));

const RELATIVE_TIME_FORMATS = {
  JUST_NOW: 'just now',
  YESTERDAY_AND_ON: d => `${d.format('h:mm A')}`,
  MORE_THAN_YEAR: d => d.format('MMM D, YYYY'),
  TOOLTIP: d => d.format('MMMM D, YYYY, h:mm:ss A')
};

const RELATIVE_TIME_FORMATS_SHORT = {
  JUST_NOW: 'just now',
  YESTERDAY_AND_ON: d => d.format('MMM D'),
  MORE_THAN_YEAR: d => d.format("MMM 'YY"),
  TOOLTIP: d => d.format('MMMM D, YYYY, h:mm:ss A')
};

const getShortTimeString = (diffMinutes, diffHours, diffDays) => {
  if (diffMinutes < 60) {
    return `${diffMinutes}m ago`;
  } else if (diffHours < 24) {
    return `${diffHours}h ago`;
  } else if (diffDays < 7) {
    return `${diffDays}d ago`;
  } else {
    const weeks = Math.floor(diffDays / 7);
    return `${weeks}w ago`;
  }
};

const NRRelativeTime = ({ value, short = false, ...props }) => {
  const date = moment(value);
  const now = moment();

  const diffSeconds = now.diff(date, 'seconds');
  const diffMinutes = now.diff(date, 'minutes');
  const diffHours = now.diff(date, 'hours');
  const diffDays = now.diff(date, 'days');
  const diffYears = now.diff(date, 'years');

  const formats = short ? RELATIVE_TIME_FORMATS_SHORT : RELATIVE_TIME_FORMATS;
  let display;

  if (diffSeconds < 60) {
    display = formats.JUST_NOW;
  } else if (diffMinutes < 60 || diffHours < 24) {
    display = short ? getShortTimeString(diffMinutes, diffHours, diffDays) : date.fromNow();
  } else if (diffYears >= 1) {
    display = formats.MORE_THAN_YEAR(date);
  } else {
    display = formats.YESTERDAY_AND_ON(date);
  }

  const tooltip = formats.TOOLTIP(date);

  return (
    <Tooltip title={tooltip}>
      <StyledTypography variant="body2" {...props}>
        {display}
      </StyledTypography>
    </Tooltip>
  );
};

export default NRRelativeTime;
